import React from "react";
import { DataGrid } from "@mui/x-data-grid";
import dayjs from "dayjs";

const columns = [
  {
    field: "submittedDate",
    headerName: "Date Submitted",
    headerAlign: "center",
    flex: 1.5,
    valueFormatter: (params) => {
      return params ? dayjs(params).format("MM/DD/YY") : "";
    },
  },
  {
    field: "reviewType",
    headerName: "Review Type",
    headerAlign: "center",
    flex: 1,
  },
  {
    field: "reviewer",
    headerName: "Reviewer",
    headerAlign: "center",
    flex: 1.5,
  },
  { field: "results", headerName: "Results", headerAlign: "center", flex: 1 },
  { field: "comments", headerName: "Comments", headerAlign: "center", flex: 3 },
  {
    field: "completedDate",
    headerName: "Date Completed",
    headerAlign: "center",
    flex: 1.5,
    valueFormatter: (params) => {
      return params ? dayjs(params).format("MM/DD/YY") : "";
    },
  },
];

const ReviewHistoryGridComponent = ({ rows }) => {
  return (
    <DataGrid
      rows={rows}
      getRowId={(row) => row.ctReviewKey}
      columns={columns}
      disableColumnSelector
      disableColumnMenu
      sx={{
        "& .MuiDataGrid-columnHeaderTitle": {
          fontWeight: "bold",
          whiteSpace: "normal",
          overflow: "visible",
          lineHeight: "1.5",
        },
      }}
    />
  );
};

export default ReviewHistoryGridComponent;
